import AppointmentBookingModalWrapper from '../../components/AppointmentsComps/BookingComps/AppointmentBookingModalWrapper';
import AppointmentSearchResults from '../../components/AppointmentsComps/BookingComps/AppointmentSearchResults';
import SearchAppointmentsForm from '../../components/AppointmentsComps/BookingComps/SearchAppointmentsForm';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import BookingProvider from '../../contexts/BookingProvider';

const Booking = () => {
  // rendering appointment booking page component here
  return (
    <>
      <PageTitle title={'Appointment Booking'} />

      <BookingProvider>
        <SearchAppointmentsForm />
        <AppointmentSearchResults />
        <AppointmentBookingModalWrapper />
      </BookingProvider>
    </>
  );
};

export default Booking;
